export default __webpack_public_path__ + "static/media/promission-publishAdd.6f0dd12d.png";